// extracted by mini-css-extract-plugin
export default {"wrapper":"Groups_wrapper__ybmKa"};